export default {
    reconciliationGridContainer: {
        marginTop: "50px"
    }
}